var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { riskTooltipRenderOptions } from './types';
import { getHighestRisk, riskLevelRender } from 'constants/riskLevel';
import { Box, Tooltip, Text } from 'shared/components';
export var RiskTooltip = function (_a) {
    var children = _a.children, isDisabled = _a.isDisabled, riskToOthers = _a.riskToOthers, riskToSelf = _a.riskToSelf, tooltipProps = __rest(_a, ["children", "isDisabled", "riskToOthers", "riskToSelf"]);
    var highestRisk = getHighestRisk(riskToOthers, riskToSelf);
    var renderOptions = highestRisk && highestRisk in riskTooltipRenderOptions
        ? riskTooltipRenderOptions[highestRisk]
        : riskTooltipRenderOptions.default;
    return (_jsx(Tooltip, __assign({}, renderOptions, { placement: "top", hasArrow: true, label: _jsxs(Box, { children: [_jsxs(Text, __assign({ size: "body2", mb: 0 }, { children: ["Harm to self: ", riskToSelf ? riskLevelRender[riskToSelf].label : 'No risk data'] })), _jsxs(Text, __assign({ size: "body2", mt: 0 }, { children: ["Harm to others: ", riskToOthers ? riskLevelRender[riskToOthers].label : 'No risk data'] }))] }), isDisabled: isDisabled }, tooltipProps, { children: children })));
};
